/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationStateTown } from './OrganizationStateTown';
import {
    OrganizationStateTownFromJSON,
    OrganizationStateTownFromJSONTyped,
    OrganizationStateTownToJSON,
    OrganizationStateTownToJSONTyped,
} from './OrganizationStateTown';

/**
 * 
 * @export
 * @interface CreateOrganizationStateTownsBulkRequest
 */
export interface CreateOrganizationStateTownsBulkRequest {
    /**
     * 
     */
    organization_state_towns?: Array<OrganizationStateTown>;
}

/**
 * Check if a given object implements the CreateOrganizationStateTownsBulkRequest interface.
 */
export function instanceOfCreateOrganizationStateTownsBulkRequest(value: object): value is CreateOrganizationStateTownsBulkRequest {
    return true;
}

export function CreateOrganizationStateTownsBulkRequestFromJSON(json: any): CreateOrganizationStateTownsBulkRequest {
    return CreateOrganizationStateTownsBulkRequestFromJSONTyped(json, false);
}

export function CreateOrganizationStateTownsBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationStateTownsBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_state_towns': json['organization_state_towns'] == null ? undefined : ((json['organization_state_towns'] as Array<any>).map(OrganizationStateTownFromJSON)),
    };
}

export function CreateOrganizationStateTownsBulkRequestToJSON(json: any): CreateOrganizationStateTownsBulkRequest {
    return CreateOrganizationStateTownsBulkRequestToJSONTyped(json, false);
}

export function CreateOrganizationStateTownsBulkRequestToJSONTyped(value?: CreateOrganizationStateTownsBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_state_towns': value['organization_state_towns'] == null ? undefined : ((value['organization_state_towns'] as Array<any>).map(OrganizationStateTownToJSON)),
    };
}

